import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { Store } from '@ngrx/store';
import { combineLatest, Observable, Subscription } from 'rxjs/index';
import { map } from 'rxjs/operators';
import { AuthenticationSelectors } from '../../../auth/state/authentication.selectors';
import { RecallsDashboardService } from './state/recalls-dashboard.service';

@Component({
    selector: 'app-dashboard-recall',
    templateUrl: './recalls-widget.component.html'
})
export class RecallsWidgetComponent implements OnInit, OnDestroy {
    private subscription: Subscription = new Subscription();
    public currentUser$: Observable<any>;
    recallDashboardWidget$: Observable<any>;
    totalRecallsCount$: Observable<number>;
    loading$: Observable<boolean>;
    viewModel$: Observable<any>;

    @ViewChild('dashboardRecallsWidget') dashboardRecallsWidget: ElementRef;

    active = true;

    constructor(
        private store: Store<any>,
        private authenticationSelectors: AuthenticationSelectors,
        private recallsDashboardService: RecallsDashboardService) {
        // Setup state selectors
        this.currentUser$ = this.authenticationSelectors.selectCurrentUser();
        this.recallDashboardWidget$ = this.recallsDashboardService.entities$;
        this.totalRecallsCount$ = this.recallsDashboardService.totalRecallsCount$;
    }

    ngOnInit(): void {
        this.recallsDashboardService.clearCache();
        const filters = {
            category: 'recalls'
        };
        this.recallsDashboardService.subscribeWebSocketJob(filters);

        this.loading$ =  combineLatest([this.recallsDashboardService.loading$, this.recallsDashboardService.refreshing$])
            .pipe(
                map(([loading, refreshing]) =>
                    loading || refreshing)
            );

        this.viewModel$ = combineLatest(
            [
                this.loading$,
                this.recallDashboardWidget$,
                this.totalRecallsCount$]
        )
            .pipe(
                map(([loading, recallDashboardWidget, totalRecallsCount]) =>
                    ({loading, recallDashboardWidget, totalRecallsCount})
                )
            );
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
        this.recallsDashboardService.unsubscribeWebSocketJob();
    }

    getDigitsClass(value): any {
        if (!value) { return 'big-numbers'; }
        if (value < 10000) { return 'big-numbers'; }
        if (value < 100000 && value >= 10000) { return 'medium-numbers'; }
        if (value >= 100000) { return 'small-numbers'; }
    }
}
